import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone } from "lucide-react";

/**
 * Floating "Call Now" button that slides down from the top of the page after
 * the user scrolls. Uses the site's phone number for GM Print.
 */
export default function CallNowButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href="tel:+61467695424"
          aria-label="Call GM Print now"
          data-testid="call-now-button"
          initial={{ y: -60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -60, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="call-now-pill"
        >
          <span className="call-now-pulse" />
          <Phone size={16} strokeWidth={2.5} />
          <span className="call-now-label">Call Now</span>
        </motion.a>
      )}
    </AnimatePresence>
  );
}
